import { storageUtils } from '@/lib/storageUtils';

const STORAGE_KEY = 'volt_ref_url';
const DEFAULT_TTL_MINUTES = 10080; // 7 days
const TTL_MINUTES =
  Number(import.meta.env.VITE_REF_URL_TTL_MINUTES) || DEFAULT_TTL_MINUTES;
const TTL_MS = TTL_MINUTES * 60 * 1000;

export const refUrlService = {
  // Saves the full landing URL (affiliate/CPS redirects) when it carries
  // query params, overwriting any previously stored value.
  capture(): void {
    if (!window.location.search) {
      return;
    }

    storageUtils.set(STORAGE_KEY, window.location.href, TTL_MS);
  },

  get(): string | null {
    return storageUtils.get<string>(STORAGE_KEY);
  },

  clear(): void {
    storageUtils.remove(STORAGE_KEY);
  },
};
